import styled from 'styled-components/native';
import { ShoppingTabs } from '~/components/shoppingTabs';

export const MobileTabs = styled(ShoppingTabs)`
    margin-top: 16px;
`;
